'use strict';

export default class Metrics {
	constructor() {
		this.init();
	}

	init() {
        let run = false;
        const time = 1500;

        const start = () => {
            if (!run) {
                run = true;
                loadMetrica();
            };
        };

        const loadMetrica = () => {
            (function(m,e,t,r,i,k,a){
                m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}
            )(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
            ym(96343654, "init", {
                clickmap:true,
                trackLinks:true,
                accurateTrackBounce:true,
                webvisor:true
            });
        };

        if (navigator.userAgent.indexOf('YandexMetrika') !== -1) {
            start();
        } else {
            window.addEventListener('mousedown', start, {once: true});
            window.addEventListener('scroll', start, {once: true});
            window.addEventListener('touchstart', start, {once: true});
            if (document.readyState == 'complete') {
                setTimeout(start, time);
            } else {
                window.addEventListener('load', () => setTimeout(start, time), {once: true});
            };
        };
    }
}